module.exports = __webpack_public_path__ + "img/53.8f39ba5d.jpg";